module.exports = "/images/d-games.png?425cadf741ae77de3964ee5bc092a974";